// FeedbackModalMUI.jsx
import React from 'react';
import { Dialog, DialogContent, CircularProgress, Typography, Button, DialogActions } from '@mui/material';

const FeedbackModalMUI = ({
  open,
  isSubmitting,
  submissionComplete,
  error,
  feedbackMessage,
  onClose
}) => (
  <Dialog
    open={open}
    onClose={isSubmitting ? () => {} : onClose}
    fullWidth
    maxWidth="xs"
    sx={{ zIndex: theme => theme.zIndex.modal + 300 }}
  >
    <DialogContent sx={{ textAlign: 'center', py: 4 }}>
      {isSubmitting ? (
        <>
          <CircularProgress size={50} thickness={4} />
          <Typography variant="h6" sx={{ mt: 2 }}>
            Processando...
          </Typography>
        </>
      ) : submissionComplete ? (
        <>
          <Typography variant="h3" color="green" sx={{ mb: 2 }}>
            ✓
          </Typography>
          {/* Aqui exibimos a mensagem dinâmica */}
          <Typography variant="h6">
            {feedbackMessage}
          </Typography>
        </>
      ) : error ? (
        <Typography variant="h6" color="error">
          {error}
        </Typography>
      ) : null}
    </DialogContent>
    {/* opcional: botão para fechar após sucesso/erro */}
    {!isSubmitting && (
      <DialogActions>
        <Button onClick={onClose}>Fechar</Button>
      </DialogActions>
    )}
  </Dialog>
);

export default FeedbackModalMUI;
